var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnelinktoLogoWhiteSimplified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "132.72095mm",
    height: "119.57207mm",
    viewBox: "0 0 132.72095 119.57207",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path1629-7-5-3-1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 2.89756
    },
    d: "M 50.000043,19.57198 A 49.999876,49.999876 0 0 0 0,69.57202 49.999876,49.999876 0 0 0 50.000043,119.57207 49.999876,49.999876 0 0 0 100.0001,69.57202 49.999876,49.999876 0 0 0 50.000043,19.57198 Z m 0,19.99981 A 29.999924,29.999924 0 0 1 80.000283,69.57202 29.999924,29.999924 0 0 1 50.000043,99.57174 29.999924,29.999924 0 0 1 19.999812,69.57202 29.999924,29.999924 0 0 1 50.000043,39.57179 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1629-7-5-3-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 2.89756
    },
    d: "M 82.720883,0 A 49.999876,49.999876 0 0 0 32.720838,50.00004 49.999876,49.999876 0 0 0 82.720883,100.00009 49.999876,49.999876 0 0 0 132.72094,50.00004 49.999876,49.999876 0 0 0 82.720883,0 Z m 0,19.99981 A 29.999924,29.999924 0 0 1 112.72112,50.00004 29.999924,29.999924 0 0 1 82.720883,79.99976 29.999924,29.999924 0 0 1 52.720653,50.00004 29.999924,29.999924 0 0 1 82.720883,19.99981 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0.503337,
      strokeWidth: 2.96097
    },
    d: "m 49.980393,39.5213 a 30.110894,29.999921 0.49661374 0 0 -17.012159,5.33529 50.184825,49.999871 0.49661447 0 0 -0.09511,1.22888 29.107205,28.999931 0.4966145 0 1 17.102059,-5.5637 29.107205,28.999931 0.4966145 0 1 4.19306,0.49278 30.110894,29.999921 0.49661374 0 1 0.3109,-1.13215 30.110894,29.999921 0.49661374 0 0 -4.49874,-0.3611 z",
    id: "path10413"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0.503337,
      strokeWidth: 2.95799
    },
    d: "m 49.856883,18.54203 a 51.086059,50.999863 0 0 0 -6.440975,0.50591 50.084382,49.999876 0 0 0 -0.796642,1.06247 50.084382,49.999876 0 0 1 7.237617,-0.56844 50.084382,49.999876 0 0 1 19.14535,3.7977 30.050628,29.999924 0 0 1 1.20195,-0.55965 51.086059,50.999863 0 0 0 -20.3473,-4.23799 z",
    id: "path1629-7-5-6-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0.503337,
      strokeWidth: 2.96447
    },
    d: "m 63.692263,96.24945 a 30.182324,29.999924 0.25 0 1 -1.17559,0.55597 51.309944,50.999863 0.25 0 0 20.16547,4.23154 51.309944,50.999863 0.25 0 0 6.55019,-0.44838 50.303877,49.999876 0.25 0 0 0.87249,-1.13965 50.303877,49.999876 0.25 0 1 -7.42531,0.58808 50.303877,49.999876 0.25 0 1 -18.98725,-3.78756 z",
    id: "path10862"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0.503337,
      strokeWidth: 2.95819
    },
    d: "m 99.861723,73.44435 a 29.052795,28.999934 0 0 1 -17.17231,5.73608 29.052795,28.999934 0 0 1 -4.11163,-0.4625 30.054608,29.999924 0 0 1 -0.34427,0.96118 30.054608,29.999924 0 0 0 4.4559,0.50126 30.054608,29.999924 0 0 0 17.06411,-5.49476 50.091016,49.999876 0 0 0 0.1082,-1.24126 z",
    id: "path10860"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnelinktoLogoWhiteSimplified);
export default __webpack_public_path__ + "static/media/onelinkto_logo_white_simplified.aff7c6108de71121fc06defce3e9c855.svg";
export { ForwardRef as ReactComponent };